import { useState } from "react";
import {
  closestCenter,
  DndContext,
  DragEndEvent,
  DragMoveEvent,
  DragStartEvent,
} from '@dnd-kit/core';
import { IFormData, ITask } from "@/api/tasks/types";
import { BoardColumn } from "./BoardColumn";
import { TaskBoard } from "./TaskBoard";
import { SortableContext, verticalListSortingStrategy } from "@dnd-kit/sortable";
import { IGroupedSection } from "../DetailProject";
import detailProjectStyles from "@features/projects/styles/detailproject.module.scss";
import { EmptyItem } from "../EmptyItem";
import { useReusableSensors } from "../../../utils/sensors";
import { useDragOverStyling } from "@/features/projects/hooks/useDragOverStyling";
import { DragOverlay } from "@dnd-kit/core";
import { createPortal } from "react-dom";

interface IDetailProjectBoardProps {
  groupedSections: IGroupedSection[] | [];
  dragMoveFn: (event: DragMoveEvent) => void;
  onDragStart: (event: DragStartEvent) => void;
  onDragEnd: (result: DragEndEvent) => void;
  newTask: (form: IFormData) => void;
  selectTask: (task: ITask) => void;
  activeTask: ITask | null;
  // fnGetAlltasks: any;
}

export const DetailProjectBoard = ({
  groupedSections,
  onDragEnd,
  onDragStart,
  newTask,
  selectTask,
  dragMoveFn,
  activeTask,
  // fnGetAlltasks
}: IDetailProjectBoardProps) => {
  const [activeId, setActiveId] = useState({ id: 0, active: false });
  const { activeDroppable, handleDragOver, resetActiveDroppable } = useDragOverStyling();

  const handleClick = (id: number) => {
    setActiveId({ id: id, active: true });
  };

  const handleCancel = (id: number, state: boolean) => {
    setActiveId({ id: id, active: state });
  };

  // const fnResponse = () => {
  //   setActiveId({ id: '', active: false })
  //   // fnGetAlltasks();
  // }
  // const handlerDelete = (id: number) => {
  //   // deleteMethod(`${urlBase}project-service/api/v1/section/${id}?email=${user?.email}`, fnResponse);
  // }

  return (
    <DndContext
      onDragStart={onDragStart}
      onDragEnd={(event) => {
        resetActiveDroppable();
        onDragEnd(event);
      }}
      onDragMove={dragMoveFn}
      onDragOver={handleDragOver}
      sensors={useReusableSensors()}
      collisionDetection={closestCenter}
    >
      <div className={detailProjectStyles["board"]}>
        <div className={detailProjectStyles["board__content"]}>
          {groupedSections?.length > 0
            ? groupedSections?.map((section: IGroupedSection) => (
              <div key={section.id} className={`
                 ${detailProjectStyles["board__column-container"]}
                 ${activeDroppable === section.id.toString()
                  ? detailProjectStyles["list__content--active"] : ''
                }`} >
                <BoardColumn
                  sectionData={section}
                  newTask={newTask}
                  activeId={activeId}
                  handleClick={handleClick}
                  handleCancel={handleCancel}
                />
                <SortableContext
                  items={section.tasks?.map((task: ITask) => task.id) || []}
                  strategy={verticalListSortingStrategy}
                >
                  <div className={detailProjectStyles["board__column-body"]}>
                    {section?.tasks?.length > 0
                      ? (section?.tasks?.map((task: ITask) => (
                        <TaskBoard task={task} selectTask={selectTask} key={task.id} />
                      )))
                      : <EmptyItem itemId={`emptyRow_${section.id}`} />
                    }
                  </div>
                </SortableContext>
              </div>
            ))
            : null}
        </div>
      </div >
      {createPortal(
        <DragOverlay>
          {activeTask ? <TaskBoard task={activeTask} selectTask={selectTask} /> : null}
        </DragOverlay>,
        document.body
      )}
    </DndContext>
  );
};
